<template>
  <section class="block-credit credit" id="credit">
    <div class="credit__container container_wide">
      <section class="credit__content">
        <h2 class="credit__title">
          Рассчитать кредит
        </h2>
        <callback-form
          class="credit__form callback-form"
          v-on="$listeners"
          :data="{ type: 'sale', form: 'competitor' }"
          :agreed="false"
        />
      </section>
    </div>
  </section>
</template>

<script>
import CallbackForm from "./callback-form";
import Mixin from "../common/mixin";
import Finance from "../common/finance";

export default {
  name: "block-credit-new",
  components: { CallbackForm },
  mixins: [Mixin, Finance],
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.credit {
  position: relative;
  width: 100%;
  height: 700px;
  margin-bottom: 100px;
  background: url("../images/credit-2.jpg") no-repeat center/cover;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    background: rgba(#000, 0.16);
  }

  &__container {
    position: relative;
    z-index: 2;
    padding: 50px 20px 20px;
    max-width: 1800px;
  }

  &__content {
    max-width: 415px;
    margin-right: auto;
  }

  &__title {
    margin-bottom: 35px;
    font-size: 30px;
    line-height: 1;
    color: #fff;
    text-transform: uppercase;
  }
}

@media (max-width: 1280px) {
  .credit {
    height: calc(100vw * 600 / 1280);
    max-height: 600px;
    min-height: 500px;
    background-position: 40% 50%;

    &__container {
      height: 100%;
    }

    &__content {
      display: flex;
      flex-direction: column;
      height: 100%;
      margin-left: 0;
    }

    &__title {
      font-size: calcFontSize(22, 28, 600, 1280);
    }

    &__form {
      margin-top: auto;
    }
  }
}

@media (max-width: 600px) {
  .credit {
    &__title {
      font-size: calcFontSize(24, 30, 320, 800);
    }
  }
}

@media (max-width: 600px) {
  .credit {
    &__content {
      max-width: 100%;
    }
  }
}
</style>
